export const AFTER_LOGIN_REDIRECT_FIELD_NAME = 'after-login-redirect-path'